var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNigeria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1342_4978)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6.375,
    y: -0.25,
    width: 37.2578,
    height: 24.7934,
    fill: "url(#pattern0_1342_4978)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1342_4978",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1342_4978",
    transform: "scale(0.00363636 0.00546448)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1342_4978"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1342_4978",
    width: 275,
    height: 183,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAIAAAC+MS2jAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABE6ADAAQAAAABAAAAtwAAAABKmt8RAAAEnUlEQVR4Ae3UMW6SARyH4Q9ksIDp0E528ACuzo6ewUN4Ao/iiRy8hIMOtomLgaTwgeLQ0KEmvKM8TED5Dzz83k7efHz/5cfX+fTZ4DEMq193d58+Xy0uYRwLfP95e/Ph7Xx5ffzm2T5f7cZ3r17PxnEzbO/X09nZQjx88f2wHzbrh5eePBLYrFfb+8kwefTmeb7YbcdxnP757hPZ/F2AWfw7BD7HPodyPAgQOFVAOaeK+TyBg4By7IBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhoBybIBAEVBOUXNDQDk2QKAIKKeouSGgHBsgUASUU9TcEFCODRAoAsopam4IKMcGCBQB5RQ1NwSUYwMEioByipobAsqxAQJFQDlFzQ0B5dgAgSKgnKLmhsChnP1uC4IAgZMEZsuL5c2Lq5Nu/uMPf/NP5Klfd3H9cnH51B/P7f3584vfd6Ur9f4diGQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeria);
export default __webpack_public_path__ + "static/media/nigeria.3b705a30e50c7f2bdcb3598eb1fe6ffb.svg";
export { ForwardRef as ReactComponent };